import { render } from "./DropdownOptions.vue?vue&type=template&id=7d96d4be&scoped=true"
import script from "./DropdownOptions.vue?vue&type=script&lang=js"
export * from "./DropdownOptions.vue?vue&type=script&lang=js"

import "./DropdownOptions.vue?vue&type=style&index=0&id=7d96d4be&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d96d4be"]])

export default __exports__